/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useEffect, useState, useRef } from "react";
import cn from "classnames";
import { CheckBoxItem } from "./CheckboxItem";
import { LayoutContext } from "../../components/layout";

export const Checkbox = ({ data, filteredCstIdList, hasSearched, globalShow, updateStatements }) => {
  const showHideIcon = require("./../../assets/esign-ui-icons/ico-showhide.svg");
  const { headerDetails: userInfo, updateHeaderDetails: updateUserInfo } = useContext(LayoutContext);
  const [show, setShow] = useState(false);
  const [initShow, setInitShow] = useState(false);
  const [cstIdListLink, setCstIdListLink] = useState([]);
  const cstIdList = useRef([]);

  const addCst = (id) => {
    updateUserInfo((prev) => {
      const newReportStatements = [...prev.reportStatements];
      newReportStatements.push({ cstId: id });
      return {
        ...prev,
        reportStatements: newReportStatements,
      };
    });
  };

  const removeCst = (id) => {
    updateUserInfo((prev) => {
      const newReportStatements = prev.reportStatements.filter((statement) => statement.cstId !== id);
      return {
        ...prev,
        reportStatements: newReportStatements,
      };
    });
  };

  const isStatementVisible = (es) => {
    const isDeviceSupported = es.applicable.some((i) => i.toUpperCase() === userInfo.device.deviceType);
    const isChecked = userInfo.reportStatements.some((it) => it.cstId == es.id);

    return isDeviceSupported && (!es.disable || isChecked);
  };

  useEffect(() => {
    setShow(globalShow);
  }, [globalShow]);

  useEffect(() => {
    cstIdList.current = userInfo.reportStatements.map((item) => item.cstId);
    const hasChecked = data.esignStatements.some((statement) => cstIdList.current.includes(statement.id));
    setInitShow(hasChecked);
    setCstIdListLink(userInfo.reportStatements.filter((item) => Object.keys(item).includes("pdfLink")));
    updateStatements(userInfo.reportStatements);
  }, [userInfo.reportStatements]);

  useEffect(() => {
    if (userInfo.reportStatements.length === 0) {
      setShow(false);
    }
  }, []);

  if (initShow || globalShow)
    return (
      <>
        <div
          className="grp-hdr"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 id="esign-stat-header">{data.name}:</h3>
          <button
            id="stat-hideShow-btn"
            className="btn btn-sm btn-hide-section btn-hide-show"
            onClick={(e) => {
              e.preventDefault();
              setShow(!show);
            }}
          >
            <span style={{ color: "#555" }}>{show ? "Hide" : "Show"}</span>
            <img id="loading-spinner" src={showHideIcon} className={cn("showhide-ico", { show: !show })} />
          </button>
        </div>
        {data.esignStatements
          .filter((es) => isStatementVisible(es))
          .map((item, ii) => {
            let shouldShow;
            let isLinked = false;
            let itemId = item.id;
            const filteredCstIdListInner = cstIdListLink.map((elem) => elem.cstId).filter((e) => e);
            const filteredPdfList = cstIdListLink.find((elem) => elem.cstId === item.id);
            const pdfNumberIndex = userInfo.reportStatements?.find((d) => d.cstId === itemId);
            const pdfPageNumber = pdfNumberIndex?.pdfLink ? pdfNumberIndex.pdfLink : 0;
            if (filteredCstIdListInner.includes(item.id) && filteredPdfList.pdfLink > 0) isLinked = true;
            if (hasSearched) {
              shouldShow = filteredCstIdList.includes(item.id);
            } else {
              shouldShow = show || cstIdList.current.includes(item.id);
            }
            return (
              <CheckBoxItem
                key={`checkboxitem-${ii}`}
                item={item}
                addCst={addCst}
                removeCst={removeCst}
                shouldShow={shouldShow}
                isLinked={isLinked}
                pageNumber={pdfPageNumber}
              />
            );
          })}
      </>
    );
  else return null;
};
